import { __awaiter, __generator } from "tslib";
import { postFeedbackInstrumentationInternal } from './postFeedbackInstrumentationInternal';
export function removeDocumentInternal(options, feedbackId) {
    return __awaiter(this, void 0, void 0, function () {
        var postFeedbackInstrumentationProps;
        return __generator(this, function (_a) {
            postFeedbackInstrumentationProps = {
                feedbackIds: [feedbackId || ''],
                actions: ['neverShowAgain'],
                timeStamp: new Date().toISOString(),
                target: '',
            };
            postFeedbackInstrumentationInternal(options, postFeedbackInstrumentationProps, true);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=removeDocumentInternal.js.map